import * as React from 'react'
import { useMemo } from 'react'
import useViewport, { Viewport } from '../../hooks/useViewport'
import { BaseOverviewHeaderItemProps, useOverviewStyles } from '../BaseOverview/BaseOverview'
import MoneyText from '../../components/Text/Currency/MoneyText'
import { BaseTimeOverviewProps, ExtendedTimeOverviewDto, TimeFilterType, TimeOverviewCount, TimeSortingType, useItemStyles } from './BaseTimeOverview'
import TimeText from '../../components/Text/Time/TimeText'
import { useSettings } from '../../hooks/useSettings'
import useCurrencies from '../../hooks/useCurrencies'
import { formatTimeInMinutes } from '../../helpers/numberHelper'
import { Checkbox, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'
import BaseOverviewCountBadge from '../BaseOverview/BaseOverviewCountBadge'

export default function TimeHeaderItem(
    props: BaseOverviewHeaderItemProps<ExtendedTimeOverviewDto, TimeFilterType, TimeSortingType, TimeOverviewCount>,
) {
    const timeProps = props as unknown as BaseTimeOverviewProps
    const itemStyles = useItemStyles()
    const overviewStyles = useOverviewStyles()
    const settings = useSettings()
    const { t: translate } = useTranslation()
    const { viewport, isViewport } = useViewport()
    const { getCurrency } = useCurrencies()

    const viewportXL = useMemo<boolean>(() => isViewport('<', Viewport.XL), [viewport])

    if (viewportXL) {
        return (
            <>
                {props.onAllItemsSelected ? (
                    <>
                        <Checkbox
                            checked={props.isAllItemsSelected?.(props.items)}
                            disabled={!props.isAllItemsSelectable?.(props.items)}
                            onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                        />
                        <div></div>
                        <div></div>
                    </>
                ) : (
                    <BaseOverviewCountBadge {...props} />
                )}
                <div></div>
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <div key={index}>
                            <TimeText value={formatTimeInMinutes(currency.duration)} />
                        </div>
                    ))}
                </div>
                <div className={props.viewportTiny ? itemStyles.listTimeItemTinyBottomRow : itemStyles.listTimeItemSmallBottomRow}>
                    <div></div>

                    <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                        <div>
                            {props.count.currencies?.map((currency, index) => (
                                <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                            ))}
                        </div>
                    </Tooltip>
                    {!props.viewportTiny && !timeProps.hideInvoiceField && (
                        <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                            <div>
                                {props.count.currencies?.map((currency, index) => (
                                    <MoneyText
                                        key={index}
                                        amount={currency.invoiceTurnover}
                                        currency={getCurrency(currency.currency)}
                                        align="right"
                                    />
                                ))}
                            </div>
                        </Tooltip>
                    )}
                </div>
            </>
        )
    }

    return (
        <>
            {props.onAllItemsSelected ? (
                <>
                    <Checkbox
                        checked={props.isAllItemsSelected?.(props.items)}
                        disabled={!props.isAllItemsSelectable?.(props.items)}
                        onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                    />
                    <div></div>
                </>
            ) : (
                <BaseOverviewCountBadge {...props} />
            )}
            <div></div>
            <div>
                {props.count.currencies?.map((currency, index) => (
                    <div key={index}>
                        <TimeText value={formatTimeInMinutes(currency.duration)} />
                    </div>
                ))}
            </div>
            <div></div>
            <div>
                <span className={overviewStyles.invisible}>
                    {settings?.fileReference?.prefix + ''.padEnd(settings?.fileReference?.length, '0') + settings?.fileReference?.suffix}
                </span>
            </div>
            <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                    ))}
                </div>
            </Tooltip>
            {!timeProps.hideInvoiceField && (
                <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                    <div>
                        {props.count.currencies?.map((currency, index) => (
                            <MoneyText key={index} amount={currency.invoiceTurnover} currency={getCurrency(currency.currency)} align="right" />
                        ))}
                    </div>
                </Tooltip>
            )}
        </>
    )
}
